module.exports = __webpack_public_path__ + "static/chicken-siomai-d19f7e6ad421a16f75f970def2980b68.jpg";